module.exports = __webpack_public_path__ + "static/media/cloud-computing.0d5d51a0.svg";